import React from 'react';

const LoginFooter = props => (
    <footer className="login_footer">
        <img src="../images/OAC_logo.png" width="150" alt="OAC_logo" />
        <div className="login_footer_txt">
            <p>地址：80661高雄市前鎮區成功二路25號7樓</p>
            <p>諮詢服務專線：0800-588-889 電話：02-27858898　<span>E-Mail：<a href="mailto:cs@universalec.com">cs@universalec.com</a></span></p>
            <p>海洋委員會海洋保育署版權所有 ©copyright 2020</p>
        </div>
    </footer>
);

export default LoginFooter;